import Tooltip, { TooltipProps, tooltipClasses } from '@mui/material/Tooltip';
import { styled } from '@mui/material/styles';

export const ErrorTooltip = styled(({ className, ...props }: TooltipProps) => <Tooltip {...props} classes={{ popper: className }} />)(
  ({ theme }) => ({
    zIndex: 1200,
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: theme.palette.error.main,
      boxShadow: theme.shadows[1],
      fontSize: 11,
      maxWidth: 200,
    },
    [`& .${tooltipClasses.arrow}::before`]: {
      color: theme.palette.error.main,
    },
  }),
);

export const LoginTooltip = styled(({ className, ...props }: TooltipProps) => <Tooltip {...props} classes={{ popper: className }} />)(
  ({ theme }) => ({
    [`& .${tooltipClasses.arrow}`]: {
      color: theme.palette.common.white,
      '&:before': {
        border: '1px solid #ccc',
      },
    },
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: theme.palette.common.white,
      color: 'black',
      fontSize: 12,
      padding: '8px 12px',
      border: '1px solid #ccc',
      borderRadius: '4px',
      boxShadow: theme.shadows[3],
      fontWeight: 400,
    },
  }),
);
